<template>

</template>

<script>
import { fetchMentionsLegales, ajoutMentionLegale } from '../../../../services/posts'
export default {
  name: 'PostFormMentionsLegalesSelect',
  props: ['post'],
  data () {
    return {
      mentionsLegales: null,
      mentionsCall: null,
      titre_mention_legale: null,
      texte_mention_legale: null
    }
  },
  beforeMount () {
    this.getMentionsLegales()
  },
  methods: {
    async getMentionsLegales () {
      this.mentionsCall = await fetchMentionsLegales()
      if (this.mentionsCall.type == 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
        this.loading = false
        return false
      }
      this.mentionsLegales = this.mentionsCall.list
    }
  }
}
</script>

<style scoped>

</style>
